import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../Constant";
import Switch from "react-switch";
import DatePicker from "react-datepicker";

export default class addCourse extends Component {
  state = {
    name: "",
    discription: "",
    categoryId: "",
    image: "",
    certification: false,
    selfEnroll: "",
    cost: "",
    selectDate: new Date(),
    content: null,
    categories: [],
  };
  componentDidMount() {
    this.getCategories();
    var uniqueCourseID = this.randomString(6, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    this.setState({ uniqueCourseID: uniqueCourseID });
  }
  randomString = (length, chars) => {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }
  handleDay = (date) => {
    this.setState({
      selectDate: date,
    });
  };
  getCategories = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        this.setState({
          categories: result.data,
          categoryId: result.data[0].id,
        });
      })
      .catch((error) => console.log("error", error));
  };
  createCourse = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    const data = {
      name: this.state.name,
      description: this.state.discription,
      image: this.state.image,
      content: {
        cost: this.state.cost,
        startDate: this.state.selectDate.toISOString(),
        selfEnroll: this.state.selfEnroll,
        certification: this.state.certification,
        isPublic: this.state.isPublic
      },
      categoryId: this.state.categoryId,
      uniqueCourseID: this.state.uniqueCourseID,
    };
    console.log(data);
    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("name", data.name);
    urlencoded.append("description", data.description);
    urlencoded.append("image", data.image);
    urlencoded.append("content", JSON.stringify(data.content));
    urlencoded.append("categoryId", data.categoryId);
    urlencoded.append("uniqueCourseID", data.uniqueCourseID);
    urlencoded.append("amount", data.content.cost);
    if (parseInt(data.content.cost) > 0) {
      urlencoded.append("isPaid", true);
    } else {
      urlencoded.append("isPaid", false);
    }
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        window.location.href = "#/admin/courses/";
      })
      .catch((error) => console.log("error", error));
  };

  uploadImg = (event) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new FormData();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("media", event.target.files[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/media/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.data[0]);
        this.setState({
          image: result.data[0],
        });
      })
      .catch((error) => console.log("error", error));
  };
  toggleIsPublic = (checked) => {
    this.setState({
      isPublic: checked,
    });
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };
  onCategoryChange = (e) => {
    console.log(e.target.value);
    this.setState({ categoryId: e.target.value });
  };

  toggleSelfEnroll = (checked) => {
    this.setState({
      selfEnroll: checked,
    });
  };
  toggleCertification = (checked) => {
    this.setState({
      certification: checked,
    });
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/courses">Courses</Link> / <b> Add Course</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Course Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Course Name"
                  id="inputDefault"
                  name="name"
                  value={this.state.name}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Course Unique Code
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Course Unique Code"
                  id="inputDefault"
                  name="uniqueCourseID"
                  value={this.state.uniqueCourseID}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                  name="categoryId"
                >
                  Category
                </label>
                <select
                  class="custom-select col-8"
                  onChange={this.onCategoryChange}
                >
                  {this.state.categories.map((category) => (
                    <option value={category.id}>{category.name}</option>
                  ))}
                </select>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Cost
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Cost for Course"
                  id="inputDefault"
                  name="cost"
                  value={this.state.cost}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Discription
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Add Course Discription"
                  id="inputDefault"
                  name="discription"
                  value={this.state.discription}
                  onChange={this.onInputChange}
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Self Enroll
                </label>
                <div>
                  <Switch
                    onChange={this.toggleSelfEnroll}
                    checked={this.state.selfEnroll}
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Certification
                </label>
                <div>
                  <Switch
                    onChange={this.toggleCertification}
                    checked={this.state.switched}
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Public Course
                </label>
                <div>
                  <Switch
                    onChange={this.toggleIsPublic}
                    checked={this.state.isPublic}
                  />
                </div>
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Select Day
                </label>
                <div className="card border card-selector col-md-8 mini  d-flex flex-row day-picker">
                  <i class="far fa-calendar-alt" />
                  <DatePicker
                    selected={this.state.selectDate}
                    onChange={this.handleDay}
                    dateFormat="MMMM d, yyyy"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center flex-column">
              <input
                type="file"
                name="selectedFile"
                onChange={this.uploadImg}
                multiple
              />
            </div>
          </div>

          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary" onClick={this.createCourse}>
              Save
            </div>{" "}
            or{" "}
            <Link to="/admin/courses" className="btn-link">
              Cancel
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
